// カテゴリーごとの定数定義
export const CATEGORIES = {
    NEW_MANSION: "new_mansion", // 新築マンション
    USED_MANSION: "used_mansion", // 中古マンション
    HOUSE: "house", // 戸建て
    NEW_HOUSE: "new_house", // 新築戸建て
    USED_HOUSE: "used_house", // 中古戸建て
    LAND: "land", // 土地
    INVEST: "invest", // 事業用
};
// マップの初期設定（総合版）
// サービス対象エリア（千葉・栃木・福島・宮城）全体が見えるよう引きで表示する
export const MAP_DEFAULT_CONFIG = {
    center: { lat: 37.0, lng: 140.3 }, // 4県のほぼ中間（福島県南部あたり）
    zoom: 7,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
};
// エリア版のマップ初期位置（key: Prefecture スラッグ = サイトモードのエリアキー）
// 選択中のエリアに応じて MAP_DEFAULT_CONFIG の center / zoom を上書きする
export const AREA_MAP_CONFIGS = {
    chiba: { center: { lat: 35.6073, lng: 140.1063 }, zoom: 10 }, // 千葉市周辺
    tochigi: { center: { lat: 36.5551, lng: 139.8828 }, zoom: 10 }, // 宇都宮市周辺
    fukushima: { center: { lat: 37.7503, lng: 140.4676 }, zoom: 10 }, // 福島市周辺
    miyagi: { center: { lat: 38.2688, lng: 140.8721 }, zoom: 10 }, // 仙台市周辺
};
// クラスタリングの設定
export const CLUSTER_CONFIG = {
    radius: 60, // クラスター形成の範囲（ピクセル）
    maxZoom: 16, // このズームレベル以上ではクラスタリングしない
};
// カテゴリーごとのマーカー色定義
export const MARKER_COLORS = {
    [CATEGORIES.NEW_MANSION]: "#FF8147CC", // 新築マンション
    [CATEGORIES.USED_MANSION]: "#FF8147CC", // 中古マンション
    [CATEGORIES.HOUSE]: "#007AFF", // 戸建て
    [CATEGORIES.NEW_HOUSE]: "#007AFF", // 新築戸建て
    [CATEGORIES.USED_HOUSE]: "#007AFF", // 中古戸建て
    [CATEGORIES.LAND]: "#008009CC", // 土地
    [CATEGORIES.INVEST]: "#6B7280", // 事業用
};
//物件の最大表示数
export const MAX_DISPLAY = 20;
